import styled from "styled-components";
import { theme } from "theme";

interface EnhancedFormFieldProps {
  mobileOptimized: boolean;
}

export const EnhancedFormField = styled.div<EnhancedFormFieldProps>`
  margin-bottom: ${theme.spacing(3)};
  
  .enhanced-field {
    .MuiOutlinedInput-root {
      border-radius: ${theme.shape.borderRadius}px;
      transition: all 0.2s ease-in-out;
      
      &:hover {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      }
      
      &.Mui-focused {
        box-shadow: 0 4px 12px rgba(129, 159, 179, 0.25);
      }
    }
    
    .MuiFormLabel-root {
      font-weight: 500;
      transform-origin: top right;
      
      ${props => props.mobileOptimized && `
        @media (max-width: 768px) {
          font-size: 0.9rem !important;
        }
      `}
    }
    
    .MuiInputBase-input {
      ${props => props.mobileOptimized && `
        @media (max-width: 768px) {
          font-size: 1rem !important;
          padding: 16px 14px !important;
          min-height: 56px !important;
        }
      `}
    }
    
    .MuiOutlinedInput-root {
      ${props => props.mobileOptimized && `
        @media (max-width: 768px) {
          min-height: 56px !important;
        }
      `}
    }
    
    .MuiFormHelperText-root {
      margin-right: 0;
      margin-left: 0;
      font-size: 0.75rem;
      
      ${props => props.mobileOptimized && `
        @media (max-width: 768px) {
          font-size: 0.8rem !important;
        }
      `}
    }
  }
`;
